<div class="container-md p-md-0">
  <div class="row g-3">
    <div class="col col-12">
      <ts-asset-selection
        header="{{ header }}"
        no_asset_text="{{ no_asset_text }}"
        [asset_fields]="asset_fields"
        [existing_asset]="shopping_cart && shopping_cart.existing_asset"
        (asset_selection_emit)="selectAsset($event)"
      />
    </div>
  </div>
</div>
